import { useState, useMemo } from 'react';
import { movies } from '@/mocks/movies';
import CategoryTabs from './CategoryTabs';
import MovieCard from './MovieCard';

export default function MovieGrid() {
  const [activeCategory, setActiveCategory] = useState('all');

  const filteredMovies = useMemo(() => {
    if (activeCategory === 'all') return movies;
    if (activeCategory === 'hot') return movies.filter((m) => m.isHot);
    return movies.filter((m) => m.categorySlug === activeCategory);
  }, [activeCategory]);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14" data-product-shop="">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-100">
              <i className="ri-film-line text-secondary-500 text-lg"></i>
            </div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              精选影视
            </h2>
          </div>
        </div>

        <CategoryTabs active={activeCategory} onChange={setActiveCategory} />

        {filteredMovies.length > 0 ? (
          <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
            {filteredMovies.map((movie) => (
              <MovieCard key={movie.id} movie={movie} />
            ))}
          </div>
        ) : (
          <div className="mt-6 py-20 text-center">
            <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-background-100">
              <i className="ri-movie-2-line text-3xl text-foreground-300"></i>
            </div>
            <p className="mt-4 text-foreground-400">暂无相关内容，请切换分类查看</p>
          </div>
        )}
      </div>
    </section>
  );
}